import { render, staticRenderFns } from "./MessageRevisionsTable.vue?vue&type=template&id=689c0e2a&scoped=true&"
import script from "./MessageRevisionsTable.vue?vue&type=script&lang=js&"
export * from "./MessageRevisionsTable.vue?vue&type=script&lang=js&"
import style0 from "./MessageRevisionsTable.vue?vue&type=style&index=0&id=689c0e2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689c0e2a",
  null
  
)

export default component.exports